'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactScroll = require('react-scroll');

var _ = require('../');

var _ScrollToTop = require('./ScrollToTop.css');

var _ScrollToTop2 = _interopRequireDefault(_ScrollToTop);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ScrollToTop = (_dec = (0, _reactCssModules2.default)(_ScrollToTop2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ScrollToTop, _Component);

  function ScrollToTop(props) {
    (0, _classCallCheck3.default)(this, ScrollToTop);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ScrollToTop.__proto__ || (0, _getPrototypeOf2.default)(ScrollToTop)).call(this, props));

    _this.state = {
      color: props.color || ''
    };
    return _this;
  }

  (0, _createClass3.default)(ScrollToTop, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'button',
        { styleName: 'scroll-to-top ' + this.state.color },
        _react2.default.createElement(
          _reactScroll.Link,
          { to: 'top', spy: true, smooth: true, offset: -50, duration: 500 },
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(_.LinkIcon, { nospace: true, faclass: 'fa-arrow-circle-o-up' }),
            ' Scroll to top'
          )
        )
      );
    }
  }]);
  return ScrollToTop;
}(_react.Component), _class2.propTypes = {
  color: _react.PropTypes.string
}, _temp)) || _class);
exports.default = ScrollToTop;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ScrollToTop/ScrollToTop.js
// module id = 1325
// module chunks = 0